import React from 'react';
const TALAB_SCREENSHOT = 'https://cdn.magicpatterns.com/uploads/nGSJjGRygrpRwUq571C6iR/image.png';

/** The live Talab product — conversational commerce powered by Vexu AI. */
export function TalabPreview() {
  return <div className="flex h-full w-full items-center justify-center px-[26px]" data-id="element-530" data-mp="2zwip8y687olv">
      <div className="w-full overflow-hidden rounded-xl border border-slate-900/[0.08] bg-white shadow-[0_18px_44px_-20px_rgba(15,23,42,0.28)]" data-id="element-531" data-mp="34vlxsslf0cyl">
        {/* Browser chrome */}
        <div className="flex items-center gap-[8px] border-b border-slate-900/[0.06] bg-slate-50 px-[12px] py-[9px]" data-id="element-532" data-mp="2uxxp0yqz54xf">
          <span className="h-[7px] w-[7px] rounded-full bg-slate-300" data-id="element-533" data-mp="2h7lukt6x2u34" />
          <span className="h-[7px] w-[7px] rounded-full bg-slate-300" data-id="element-534" data-mp="2l8e6ju76bd33" />
          <span className="h-[7px] w-[7px] rounded-full bg-slate-300" data-id="element-535" data-mp="2l8nw5gob3i89" />
          <span className="ml-[8px] rounded-md bg-white px-[10px] py-[3px] text-[9.5px] font-medium tracking-[0.02em] text-slate-500 ring-1 ring-slate-900/[0.06]" data-id="element-536" data-mp="279xzg25efkkf">
            app.talab.app
          </span>
          <span className="ml-auto rounded-full border border-vexu/30 bg-vexu/[0.08] px-[8px] py-[3px] text-[8px] font-semibold uppercase tracking-[0.14em] text-vexu-700" data-id="element-537" data-mp="smjtnu6h06bu">
            Powered by Vexu AI
          </span>
        </div>

        <div className="h-[212px] overflow-hidden bg-white" data-id="element-538" data-mp="11m6uoevafa4d">
          <img src={TALAB_SCREENSHOT} alt="Talab conversational commerce interface showing AI-matched vehicle results" className="h-full w-full object-cover object-left-top" data-id="element-539" data-mp="wqrh7o16zg8h" />
        </div>
      </div>
    </div>;
}